import axios from 'axios'
import { ALTERAR_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarUsuario (usuario, idEmpresa) {
  const url = `${URL}/usuarios/empresa/${idEmpresa}/alterar`;
  return dispatch => axios.post(url,usuario , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_USUARIO,
        payload: response
      })
  );
}
